// extracted by mini-css-extract-plugin
export default {"AdminDeleteReviewModal":"AdminDeleteReviewModal_AdminDeleteReviewModal__oFshH","message":"AdminDeleteReviewModal_message__sSv6U","controls":"AdminDeleteReviewModal_controls__HnmS9"};